import Card from '../../../../../common/components/ContainerCard';
import { ICustomerItem } from '../../../../../models/Account/ICustomerItem';
import styles from './CredentialsCard.module.css';

type CredentialCardProps = {
  credentialData: ICustomerItem;
};

const CredentialCard = (props: CredentialCardProps) => {
  return (
    <Card className={styles.smallCardDimensions}>
      <div className={styles.subtitleBold}>{props.credentialData.itemName}</div>
      <div className={styles.subtitleRegular}>Expires: {props.credentialData.expirationDate}</div>
    </Card>
  );
};

export default CredentialCard;
